import { c as _c } from "react/compiler-runtime";
import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { cn } from "../utils";
function Textarea(t0) {
  const $ = _c(10);
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    const {
      className,
      render,
      ...props
    } = t0;
    t4 = useRender;
    t1 = "textarea";
    t2 = render;
    t3 = mergeProps(props, {
      className: cn("flex field-sizing-content min-h-16 w-full rounded-md border border-input bg-transparent px-3 py-2 text-base transition-colors outline-none md:text-sm", "placeholder:text-muted-foreground", "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50", "aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40", "disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 dark:disabled:bg-input/80", "dark:bg-input/30", className)
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      slot: "textarea"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t6 = {
      defaultTagName: t1,
      render: t2,
      props: t3,
      state: t5
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t4(t6);
}
export { Textarea };